<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">ALSO BY GILLIAN JACKSON</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="content-external-link">The Pharmacist</span></p>
<p class="subsq also-by-content"><span class="content-external-link">The Victim</span></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/TheDeceptionGJ" target="_blank">The Deception</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/Abduction" target="_blank">Abduction</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/SnatchedGJ" target="_blank">Snatched</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/TheAccident" target="_blank">The Accident</a></p>
<p class="subsq also-by-content"><span class="content-external-link">The Shape of Truth</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobygillianjackson.vue?3a05857a